//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Gender

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The user model
* 
* @param emailAddress The user email (and login username)
* @param familyName The family name of the user
* @param givenName The given name
* @param academicTitle The academic title of the user
* @param dateOfBirth The birth date of the user
* @param displayName The display name of the user
* @param gender 
*/
@Serializable

data class UserData (


      /* The user email (and login username) */
    @SerialName(value = "emailAddress") @Required val emailAddress: kotlin.String,


      /* The family name of the user */
    @SerialName(value = "familyName") @Required val familyName: kotlin.String,


      /* The given name */
    @SerialName(value = "givenName") @Required val givenName: kotlin.String,


      /* The academic title of the user */
    @SerialName(value = "academicTitle") val academicTitle: kotlin.String? = null,


      /* The birth date of the user */
    @SerialName(value = "dateOfBirth") val dateOfBirth: kotlin.time.Instant? = null,


      /* The display name of the user */
    @SerialName(value = "displayName") val displayName: kotlin.String? = null,


      @SerialName(value = "gender") val gender: Gender? = null


) {




  }

